<div class="dialog">
  <div class="dialog-background" (click)="goToTab(5)"></div>
  <div class="dialog-content">
    <p>{{ 'modals.missing_wish.p1' | translate }}</p>
    <p class="companies">
      <span *ngFor="let discardedWish of discardedWishes; let isLast = last">
        <strong>{{ discardedWish }}</strong>
        <span *ngIf="!isLast">, </span>
      </span>
    </p>
    <p>{{ (kind === '3a' ? 'modals.missing_wish.p2_3a' : 'modals.missing_wish.p2') | translate }}</p>
    <div class="ui-button-group reverse">
      <button (click)="goToTab(4)" class="ui-button secondary">
        {{ 'modals.missing_wish.back' | translate }}
      </button>
      <button (click)="goToTab(5)" class="ui-button">{{ 'modals.missing_wish.go' | translate }}</button>
    </div>
  </div>
</div>
